import React from "react";
import { Button } from "@anchor/react-components"; // adjust to your actual import

interface ConfirmModalProps {
  visible: boolean;
  title?: string;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
  confirmLabel?: string;
  cancelLabel?: string;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  visible,
  title = "Confirm Action",
  message,
  onConfirm,
  onCancel,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
}) => {
  if (!visible) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        height: "100vh",
        width: "100vw",
        backgroundColor: "rgba(0,0,0,0.1)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
    >
      <div
        style={{
          background: "#fff",
          padding: "24px",
          borderRadius: "8px",
          width: "400px",
          maxWidth: "90%",
        }}
      >
        <h5>{title}</h5>
        <p>{message}</p>
        <div className="d-flex gap-2 justify-content-end mt-3">
          <Button name="Cancel" label={cancelLabel} onClick={onCancel} />
          <Button name="Confirm" label={confirmLabel} onClick={onConfirm} />
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
